import {
  initAllBanners,
  observeBannerInsertions
} from "components/jiffy/promotion-banner/promotion-banner";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initAllBanners();
    observeBannerInsertions();
  });
} else {
  initAllBanners();
  observeBannerInsertions();
}
